module.exports = __webpack_public_path__ + "static/media/themesberg-logo.bbd344a3.svg";